import { useEffect, useState } from 'react'

import request, { queryClient } from 'core/config/request'
import TokenHelper from 'common/helpers/token/tokenHelper'

const setRequestHeaders = (token: string) => {
  request.defaults.headers.common.Authorization = `Bearer ${token}`
}

const clearRequestHeaders = () => {
  delete request.defaults.headers.common.Authorization
}

export const useResetRequestConfig = () => {
  const token = TokenHelper.getToken()

  const [isResetting, setIsResetting] = useState<boolean>(true)

  useEffect(() => {
    const resetQueries = async () => {
      await queryClient.resetQueries()
      setIsResetting(false)
    }

    setRequestHeaders(token)
    resetQueries()

    return () => clearRequestHeaders()
  }, [token])

  return { isResetting }
}
